//@state
export interface reportState {
  report:boolean
}

export const initialState: reportState = {
  report:true
}
